import { render, staticRenderFns } from "./Revaluation.vue?vue&type=template&id=4e2468a6&scoped=true"
import script from "./Revaluation.vue?vue&type=script&lang=ts"
export * from "./Revaluation.vue?vue&type=script&lang=ts"
import style0 from "./Revaluation.vue?vue&type=style&index=0&id=4e2468a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2468a6",
  null
  
)

export default component.exports